import { t } from '@avalara/bat-apps-shared/i18n';
import { SCol, SRow } from '@avalara/skylab-sdk/react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { selectState } from '../../selectors';
import Loading from '../loading';
import PageNotFound from '../page-not-found';
import { PageWrapper } from '../styled/skylab/page';
import { getExistingSessionRedirect } from './existing-session-redirect';
import { hideShellChrome } from './hide-shell-chrome';
import LeadForm from './lead-form';

// Marketing copy for this page is owned by Ryan's team, not this ticket (PF-8561) - the
// heading/subheading below are placeholders so the layout has room for it.
//
// No top-level SContainer here - AvaApp's shell already wraps every route's <main> in one;
// adding a second nests them and breaks mobile layout.
const AviatorCrushLanding = () => {
  const { data, features } = useSelector(selectState);
  // Gated by enableAviatorCrush (avalara-ui!5516) rather than the route itself, matching
  // ProductCatalog's shouldShowProductCatalog pattern - keeps /aviator-crush always registered
  // in app.tsx (so it doesn't fall through to the /:requestedOfferFlow catch-all) while still
  // controlling when the event page actually goes live, and letting it be killed quickly if needed.
  //
  // Wait for data.featuresLoaded before treating the flag as off, same reason ProductCatalog's
  // shouldRender does: configureFeatures dispatches its /api/features result and any
  // ?enableAviatorCrush=true query-param override asynchronously, so features.ENABLEAVIATORCRUSH
  // reads as falsy on first render regardless of the real value. Redirecting to PageNotFound on
  // that first render fires before the override is ever applied.
  const enabled = !!features.ENABLEAVIATORCRUSH;

  const redirectUrl = enabled ? getExistingSessionRedirect() : null;

  useEffect(() => {
    if (!enabled) return;
    return hideShellChrome();
  }, [enabled]);

  useEffect(() => {
    if (redirectUrl) window.location.href = redirectUrl;
  }, [redirectUrl]);

  if (!data.featuresLoaded) return null;
  if (!enabled) return <PageNotFound />;
  if (redirectUrl) return <Loading />;

  return (
    <PageWrapper>
      <SRow className='pad-all-sm justify-content-center'>
        <SCol center='' span='sm-10 md-8 lg-6'>
          <h1 className='pad-bottom-sm'>{t('client.aviatorCrush.heading')}</h1>
          <p className='pad-bottom-md'>{t('client.aviatorCrush.subheading')}</p>
          <LeadForm />
        </SCol>
      </SRow>
    </PageWrapper>
  );
};

export default AviatorCrushLanding;
